import { observer } from 'mobx-react';
import React from 'react';
import moment from 'moment/moment';
import Text from '~/view/components/Text/Text';
import CustomTooltip, { TOOLTIP_POSITION, TOOLTIP_TYPE } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from '~/view/components/Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';
import { localeStore } from '~/mobx/localesStore';

interface IProps {
  lastSyncDate: Date;
}

const T360LastSyncDate: React.FC<IProps> = observer((props: IProps) => {
  return (
    <div className="d-flex flex-row align-items-end justify-content-start mt-5">
      <Text
        text={`${localeStore.t('t2_foodics_last_sync')} ${moment(props.lastSyncDate, 'DD-MM-YYYY h:mm A').format('DD-MM-YYYY h:mm A')}`}
        type="recommendation"
        className="mr-1"
      />
      <CustomTooltip position={TOOLTIP_POSITION.FIXED} type={TOOLTIP_TYPE.INFO} message={localeStore.t('sync_info_t360')}>
        <Icon name={Icons.Info} size={20} className="cursor-pointer color-gray2" />
      </CustomTooltip>
    </div>
  );
});

export default T360LastSyncDate;
